<template>
  <v-dialog
    data-testid="create_rev_modal"
    data-tourid="create_rev_modal"
    max-width="750"
    max-height="70vh"
    scrollable
    :value="show"
    :persistent="isLoading"
    @click:outside="handleClose"
    @keydown.esc="handleClose"
  >
    <CreateRevWrapper
      :challengeId="challengeId"
      :type="type"
      @created="$emit('created')"
      @error="$emit('error')"
      @loading="isLoading = true"
      @visitSuggestion="$emit('visitSuggestion')"
    >
      <template slot-scope="{ create, cancel, isLoading, isValid }">
        <Button
          plain
          color="grey"
          data-testid="revs_modal_create_cancel"
          data-tourid="revs_modal_create_cancel"
          :disabled="isLoading"
          :text="$t('common.button.cancel')"
          @click="
            cancel()
            handleClose()
          "
        />
        <Button
          color="primary"
          data-testid="create_rev_button"
          data-tourid="create_rev_button"
          :disabled="isValid"
          :loading="isLoading"
          :text="$t('common.button.create')"
          @click="create"
        />
      </template>
    </CreateRevWrapper>
  </v-dialog>
</template>

<script>
import CreateRevWrapper from '@/components/CreateRevWrapper/CreateRevWrapper.vue'
import Button from '@/components/UI/Button.vue'

export default {
  name: 'CreateRevActionModal',

  data() {
    return {
      isLoading: false,
    }
  },

  props: {
    show: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      required: true,
    },

    challengeId: {
      type: String,
      required: false,
    },
  },

  components: {
    Button,
    CreateRevWrapper,
  },

  methods: {
    handleClose() {
      if (this.isLoading) return
      this.$emit('close')
    },
  },
}
</script>
